import LocaleForm from 'CoreComponents/localeForm';

if (document.querySelector('.form-locale')) {
  new LocaleForm();
}
